import { escape } from 'lodash'

import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import entity from '@/components/entity'
import empty from '@/components/services/dictionaries/empty'
import sticker from '@/components/sticker'

const headers = [ 'mcc', 'mnc', 'type', 'operator', 'group', 'regionCode', 'regionName', 'countryCode', 'countryName', 'timeZone' ]

function renderTitle(h) {
  return h(
    sticker,
    {
      props: {
        value: this.getTranslate(`${Services.hlr}.title`),
        label: this.getTranslate('misc.search'),
        iconSVG: Services.hlr,
        color: Services.hlr
      }
    }
  )
}

function renderSearchField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.searchQuery,
        label: this.getTranslate(`${Services.hlr}.labels.search`),
        disabled: this.loading,
        clearable: true,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.searchQuery = event
        }
      }
    }
  )
}
function renderSubmitButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('commons.labels.search'),
        mode: buttonModes.flat,
        color: Colors.primary,
        loading: this.loading,
        disabled: this.loading || !this.validation,
        type: 'submit'
      }
    }
  )
}
function renderForm(h) {
  return h(
    components.form,
    {
      class: `${Services.hlr}-form`,
      on: {
        submit: () => {
          return this.search()
        }
      }
    },
    [
      renderSearchField.call(this, h),
      renderSubmitButton.call(this, h)
    ]
  )
}

function renderHeader(h) {
  return h(
    'div',
    {
      class: `${Services.hlr}-header`
    },
    [
      renderTitle.call(this, h),
      renderForm.call(this, h)
    ]
  )
}

function renderResult(h) {
  if (this.searchResult) {
    const value = {}
    for (const header of headers) {
      value[header] = escape(this.searchResult[header])
    }

    return h(
      entity,
      {
        props: {
          value,
          service: Services.dictionaries,
          fields: headers
        }
      }
    )
  }

  let state = 'default'
  if (this.empty) {
    state = 'search'
  }

  return h(
    empty,
    {
      props: {
        state
      }
    }
  )
}
function renderBody(h) {
  return h(
    components.card,
    {
      class: {
        [`${Services.hlr}-body`]: true,
        [`${Services.hlr}-body--result`]: !!this.searchResult
      },
      props: {
        outline: true,
        dashed: true,
        rounded: true
      }
    },
    [ renderResult.call(this, h) ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: Services.hlr
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h)
    ]
  )
}
